import { ParameterSpace } from "features/morphing/state/parameterAtoms";

export const isNaturalParameterSpace = (
  parameterSpace: ParameterSpace
) => {
  return (
    Number.isInteger(parameterSpace.lower) &&
    Number.isInteger(parameterSpace.upper)
  );
};

export const isValidParameterSpace = (
  parameterSpace: ParameterSpace
) => {
  return (
    isNaturalParameterSpace(parameterSpace) &&
    parameterSpace.lower <= parameterSpace.upper
  );
};
